module.exports = __webpack_public_path__ + "img/cook_island.cd5874a.webp";